module.exports = __webpack_public_path__ + "img/google-play.de8d9de6.de8d9de6.svg";